import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import { useModal } from 'store/modal';
import API from 'core/Api';
import { createErrorFromResponse } from 'core/Error';
import setServerErrors from 'utils/helpers/formErrors';

interface IProps {
  children: any;
  methods: any;
  onSuccess?: any;
  entity: string;
  queryKey?: any;
  onSuccessPushToLink?: string;
  onError?: any;
}

const CreateEntity: FC<IProps> = ({
  children,
  methods,
  onSuccess,
  entity,
  queryKey,
  onSuccessPushToLink,
  onError,
}: IProps) => {
  const { showModal } = useModal();
  const history = useHistory();
  const queryClient = useQueryClient();

  const options = {
    onSuccess: (res: any) => {
      if (queryKey) {
        if (typeof queryKey === 'object') {
          queryKey.map((query: string) => queryClient.invalidateQueries(query));
        } else if (typeof queryKey === 'string') {
          queryClient.invalidateQueries(queryKey);
        }
      }
      if (onSuccessPushToLink) history.push(onSuccessPushToLink);
      onSuccess(res);
    },
    onError: (res: any) => {
      const error = createErrorFromResponse(res);
      if (error.errors && typeof error.errors !== 'string') {
        return setServerErrors(error.errors, methods.setError);
      }
      showModal({
        type: 'error',
        content: error.message,
      });
      onError(res);
    },
  };

  const { mutate, data } = useMutation(inputData => API.post(entity, inputData), options);

  const create = (variables: any) => {
    return new Promise((resolve, reject) => {
      mutate(variables, {
        onSuccess: resolve,
        onError: reject,
      });
    });
  };

  return <>{children(create, data)}</>;
};

export default CreateEntity;
